// export const lightTheme = {
//     colors: {
//       primary: 'blue',
//       secondary: 'green',
//     },
//     fonts: {
//       body: 'Helvetica, sans-serif',
//       heading: 'Arial, sans-serif',
//     },
//   };
  
export const darkTheme = {
    colors: {
        primary: '#0C98CC',
        secondary: '#F9BE10',
    },
    fonts: {
        body: 'Helvetica, sans-serif',
        heading: 'Arial, sans-serif',
    },
};